export default {
  AuthStore: () => import('./AuthStore'),
  SessionStore: () => import('./SessionStore'),
  PassportStore: () => import('./PassportStore'),
};
